$(document).ready(function() {

    var api_protocol;
    var api_hostname;
    var api_path;

    if (window.location.hostname.indexOf('soupmail.com') > 0) {
        api_protocol = 'https://';
        api_hostname = window.location.hostname;
        api_path = '/api';
    } else {
        api_protocol = 'https://';
        api_hostname = 'dev.soupmail.com';
        api_path = '/api';
    }

    $.getJSON(api_protocol+api_hostname+api_path+'/terms.json',function(data){
        jQuery('.terms-conditions').html(data['content']);
    });
});

function goToSoupmail(){
    document.location.replace('https://'+window.location.hostname);
}


// WEBPACK FOOTER //
// ./src/js/terms_and_conditions_app.js